/* eslint-disable no-restricted-exports */
import { QueryClient, VueQueryPlugin } from "@tanstack/vue-query";

export default defineNuxtPlugin({
    // named, so plugins that use stores (vue-query mutations) can depend on it
    name: "vue-query",
    setup(nuxtApp) {
        const queryClient = new QueryClient({
            defaultOptions: {
                queries: { refetchOnWindowFocus: false, staleTime: 5000 },
            },
        });

        nuxtApp.vueApp.use(VueQueryPlugin, { queryClient });
    },
});
